module.exports = __webpack_public_path__ + "static/media/icon_effervescent.932acd93.svg";